/**
 * Created by Jie Gao on 11/11/18.
 */
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {Timeline, TimelineLite} from "gsap";
import {StarStruckBetlineEvent} from "../../betline/StarStruckBetlineEvent";
import {StarStruckParsedGameData} from "../../server/data/StarStruckParsedGameData";
import {StarStruckGameConfig} from "../../StarStruckGameConfig";
import BitmapText = PIXI.BitmapText;

export class StarStruckBetLineWinIndividualWPController extends BetLineWinIndividualWPController {

    private _reelsNum:number = 3;
    private _symbolsNum:number = 3;
    private _symbolWinStates:boolean[][];
    private _totalWinText:BitmapText;
    private _totalWin:number;

    constructor(config:IIndividualWinPresentationConfig, name:string = "BetLineIndividualWin", tweakEnabled?:boolean,) {
        super(config, name, tweakEnabled);
    }

    protected parseFeatureGameData(data:StarStruckParsedGameData):void {
        this._totalWin = data.singleWin;
        this._symbolWinStates = ArrayHelper.initArrayWithValues<boolean[]>(this._reelsNum, () => {
            return ArrayHelper.initArrayWithValues<boolean>(this._symbolsNum, () => false)
        });

        (<IBetLineWinData[]>this._betWinsData!).forEach((betLineWinData:IBetLineWinData) => {
            for(let reelId:number = 0; reelId < betLineWinData.nrOfSymbols; reelId++) {
                const symbolId:number = betLineWinData.betLine[reelId];
                this._symbolWinStates[reelId][symbolId] = true;
            }
        });
    }

    protected startWinPresentation():void {
        if(!this._totalWinText) {
            this.createTotalWinText();
        }
        if(this.playAllNoWinSymbols) {
            this.playAllNoWinSymbols();
        }

        this.playNextBetLinePresentation();
    }

    private createTotalWinText():void {
        this._totalWinText = new BitmapText("0", {
            fontName : "NumbersWinCountUp",
            fontSize : 20
        });
        this._totalWinText.visible = false;
        StageManager.getLayer(StarStruckGameConfig.instance.LAYERS.FOREGROUND.name).addChild(this._totalWinText);

    }

    private playNextBetLinePresentation():void {
        this.resetWinSymbols(false);

        // play next line
        this._currentIndex++;

        this._currentLineAnimation = new TimelineLite();
        // Add 0.1 time offset here to make sure the resetWinSymbols have time to finish.
        if(this._currentIndex >= this._betWinsData!.length) {
            this._currentIndex = -1;
            //this._currentLineAnimation.add(this.getAllLineAnimation(this._betWinsData!), 0.1);
        } else {
            //StarStruckBetlineEvent.SHOW_WIN_BET_LINE_WINS
            this._currentLineAnimation.add(this.getLineAnimation(<IBetLineWinData>this._betWinsData![this._currentIndex]), 0.1);
        }
        this._currentLineAnimation.add(() => {
            this.playNextBetLinePresentation();
        });
    }

    /*protected getAllLineAnimation(betWinsData:IBetWinData[]):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(() => {
            this._totalWinText.text = (this._totalWin.toFixed(2)).toString();
            this._totalWinText.x = Helper.getSymbolPositions(1,1)[0] - this._totalWinText.width/2;
            this._totalWinText.y = 340-this._totalWinText.height/2;
            this._totalWinText.visible = true;
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            betWinsData.forEach((betlineWinData:IBetLineWinData, index:number) => {
                EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_WIN_BET_LINE, betlineWinData.betLineIndex + 1));
            });

        });
        this._symbolWinStates.forEach((winStates:boolean[], i:number) => {
            winStates.forEach((winState:boolean, j:number) => {
                if(winState){
                    timeline.add(Reels.getSymbol(i, j)!.changeState({
                        state : GameConfig.instance.SYMBOL_STATES.win,
                        setStack : true,
                        fadeInDuration : 0.1
                    })!, 0);
                }
            });
        });
        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            this._totalWinText.visible = false;
        }, 1);

        return timeline;
    }
*/
    protected getLineAnimation(betLineWinData:IBetLineWinData):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            EventHandler.dispatchEvent(new GameEvent(StarStruckBetlineEvent.SHOW_WIN_BET_LINE_WINS, betLineWinData.betLineIndex + 1));
        });

        for(let i:number = 0; i < betLineWinData.nrOfSymbols; i++) {
            const symbol = Reels.getSymbol(i, betLineWinData.betLine[i]);
            if(symbol) {
                this.addSymbolWinAnimationToTimeline(betLineWinData, timeline, this._config.symbolTimeOffsetCalculator(timeline.totalDuration(), i, betLineWinData.betLine[i]), symbol, i, betLineWinData.betLine[i]);
                this._winSymbols.push(symbol);
            }
        }

        return timeline;
    }

    protected stopWinPresentation(isAborted:boolean):void {
        super.stopWinPresentation(isAborted);
        if(!this._totalWinText) {
            this.createTotalWinText();
        }
        this._totalWinText.visible = false;
    }
}